import SyncHelper from './syncHelper';
import {EventBus} from '../eventBus.js';

function isStandaloneiOS() {
  return /iP(hone|od|ad)/.test(navigator.userAgent) &&
         ('standalone' in window.navigator && window.navigator.standalone);
}

var AjaxHelper = {
  isActive: false,
  callFininshed: false,
  callInprogress: false,
  infinites: [],
  extraLoginData: null,
  lel: {},

  destroyInfinite(name) {
    if (this.infinites[name]) {
      delete this.infinites[name];
    }
  },

  doRequestInfinite(ws, method, data, options, requestType) {
    if (!this.infinites[method]) {
      this.infinites[method] = {
        active: true,
        done: false,
        timesCalled: 0,

        tracker: {
          start: 0
        },

        settings: {
          limit: 50
        },

        reset() {
          this.tracker.start = 0;
          this.active = false;
        },

        finished() {
          this.reset();
          this.done = true;
        }
      };
    }

    if (!this.infinites[method].active || this.infinites[method].done) return;

    this.infinites[method].active = true;
    data.start = this.infinites[method].tracker.start;
    this.doRequest(ws, method, data, options, requestType);
  },

  doRequest(ws, method, data, options, requestType) {
    this.isActive = true;
    this.start(options);

    const dataOriginal = data; // ✅ Bewaar originele payload voor eventuele retry

    var requestParams = {
      data: {
        service: ws,
        method: method,
      }
    };

    requestParams.data = $.extend(requestParams.data, data);

    requestParams.data.app = $Config.app.currentApp;
    requestParams.data.language = $LanguageHelper.current;
    requestParams.data.version = $Config.app.version;

    requestParams.data.clientUserAgent = $Config.app.onDevice ? $Config.app.platform : 'browser';

    if ($UserHelper.getToken() && $UserHelper.getToken().length > 0) {
      requestParams.data.token = $UserHelper.getToken();
    }

    if (requestParams.data.idc) {
      if ($Config.app.forceSync) {
        var company = $UserHelper.getCompany(requestParams.data.idc);
        if (company && !company.forceSyncDone) {
          requestParams.data.forceSync = 1;
          $UserHelper.companyForceSyncDone(requestParams.data.idc);
        }
      }

      requestParams.data.id_gym = requestParams.data.idc;
      requestParams.data.companySyncVersions = SyncHelper.getVersions(data.idc);
    }

    requestParams.data.id_appuser_li = $UserHelper.getID();

    var retryAttempt = options && options._retryAttempt ? options._retryAttempt : 1;

    $.ajax({
      type: $Config.app.servercallType,
      url: $Config.app.baseURL,
      data: requestParams,
      dataType: 'json',
      timeout: 15000,
      success(dataCallback) {
        if (dataCallback.params_send && dataCallback.params_send.idc && dataCallback.syncCommands) {
          var routerParams = $ViewHelper.router.getParams();
          SyncHelper.sync(dataCallback.params_send.idc, dataCallback.syncCommands, (routerParams && routerParams.idc ? true : false));
        }

        if (dataCallback.stop_app) {
          $ViewHelper.alert($FunctionsHelper.nl2br(dataCallback.stop_app.reason), $LanguageHelper.translate('_NOTICE_'));
          throw new Error(dataCallback.stop_app.reason);
        }

        if (dataCallback.extraLoginExpired) {
          AjaxHelper.triggerExtraLogin(ws, method, data, options);
        }

        if (dataCallback.notice && !dataCallback.suppressNotice) {
          dataCallback.notice = $FunctionsHelper.nl2br(dataCallback.notice);
          $ViewHelper.alert(dataCallback.notice, $LanguageHelper.translate('_NOTICE_'));
        }

        let unreadMessages = dataCallback.unread_messages && dataCallback.unread_messages > 0 ? dataCallback.unread_messages : 0;
        let numberNotifications = localStorage.getItem('numberNotifications');
        if (!numberNotifications || (numberNotifications != unreadMessages)) {
          EventBus.$emit('notifications', unreadMessages);
        }

        if (dataCallback.fatalError || dataCallback.exception) {
          return AjaxHelper.somethingWentWrong(dataCallback);
        }

        if (options && options.callback) {
          if (dataCallback.gyminfo && dataCallback.gyminfo.lel) {
            AjaxHelper.lel = {
              lel: dataCallback.gyminfo.lel,
              lel_min: dataCallback.gyminfo.lel_min
            };
          }

          if (AjaxHelper.infinites[method] && AjaxHelper.infinites[method].active) {
            AjaxHelper.infinites[method].tracker.start += AjaxHelper.infinites[method].settings.limit;
          }

          options.callback(dataCallback);
        }

        AjaxHelper.isActive = false;
      },

      error(data) {
        AjaxHelper.finish(); // 🔧 close spinner for first call

        // ✅ Retry logic voor iOS Safari standalone readyState 0
        if (retryAttempt === 1) {
          console.log('Retrying request due to iOS Safari readyState 0...');
          var newOptions = Object.assign({}, options || {}, { _retryAttempt: 2 });
          setTimeout(function() {
            AjaxHelper.doRequest(ws, method, dataOriginal, newOptions, requestType); // ✅ gebruik originele data
          }, 300);
          return;
        }

        console.log(data);
        AjaxHelper.finish();
        AjaxHelper.somethingWentWrong(data);
      },

      complete() {
        AjaxHelper.finish();
      }
    });
  },

  start(options) {
    if (!options || !options.hideIndicator) {
      $ViewHelper.preloader.show();
    }

    this.callFininshed = false;
    this.callInprogress = true;
  },

  finish() {
    $ViewHelper.preloader.hide();
    this.callFininshed = true;
    this.callInprogress = false;
  },

  somethingWentWrong(data) {
    if (!$Config.app.live) {
      console.log(data);
    }

    let errorMessage = $LanguageHelper.translate('_SOMETHING_WENT_WRONG_TEXT_');

    if (data) {
      let detailedError = '';

      try {
        detailedError = JSON.stringify(data, null, 2);
      } catch (e) {
        detailedError = String(data);
      }

      if (detailedError && detailedError.trim()) {
        errorMessage += '\n\nDetails:\n' + detailedError;
      }
    }

    $ViewHelper.alert(errorMessage, $LanguageHelper.translate('_WHOOPS_'));
  },

  doRequestExtraLogin(ws, method, data, options, callback) {
    var lastMoment = null;
    if (AjaxHelper.lel && AjaxHelper.lel.lel) {
      lastMoment = moment(AjaxHelper.lel.lel);
    }

    if (!lastMoment || !lastMoment.isValid() || moment().subtract(AjaxHelper.lel.lel_min, 'm').toDate().getTime() > lastMoment.toDate().getTime()) {
      AjaxHelper.triggerExtraLogin(ws, method, data, options, callback);
    } else {
      this.doRequest(ws, method, data, options);
    }
  },

  sendExtraLogin(pass) {
    AjaxHelper.doRequest('user', 'loginExtra', { pass: pass }, {
      callback: function(dataCallback) {
        if (dataCallback.status && dataCallback.status == 'OK') {
          $ViewHelper.popup.close('popupExtralogin');
          $ViewHelper.popup.removeMeFromNativeHistoryStack();
          AjaxHelper.doRequest(
            AjaxHelper.extraLoginData.ws,
            AjaxHelper.extraLoginData.method,
            AjaxHelper.extraLoginData.data,
            AjaxHelper.extraLoginData.options,
            AjaxHelper.extraLoginData.requestType
          );
          AjaxHelper.extraLoginData = null;
        }
      }
    });
  },

  triggerExtraLogin(ws, method, data, options, callback) {
    AjaxHelper.extraLoginData = { ws, method, data, options };
    $ViewHelper.popup.showExtraLogin(callback);
  }
};

export default AjaxHelper;
